import { useTabList } from '@react-aria/tabs'
import { useTabListState } from '@react-stately/tabs'
import { Tab } from './Tab'
import Styles from './Tabs.module.scss'
import { useObjectRef } from 'utils/useObjectRef'
import { AriaTabListProps, SpectrumTabsProps } from '@react-types/tabs'
import { TabPanel } from './TabPanel'

export const Tabs = (props: SpectrumTabsProps<HTMLDivElement>) => {
  const state = useTabListState(props as AriaTabListProps<HTMLDivElement>)
  const ref = useObjectRef<HTMLDivElement>()
  const { tabListProps } = useTabList(props as AriaTabListProps<HTMLDivElement>, state, ref)
  const itemWithFraction = 100 / state.collection.size
  const translate = `-${itemWithFraction * (state.selectedItem?.index || 0)}%`

  return (
    <>
      <div {...tabListProps} ref={ref} className={Styles.tabs}>
        {[...state.collection].map((item) => (
          <Tab key={item.key} item={item} state={state} />
        ))}
      </div>
      <div className={Styles.tabsContainer}>
        <div
          style={{
            width: `${100 * state.collection.size}%`,
            transform: `translateX(${translate})`,
          }}
          className={Styles.tabsContainerInner}
        >
          {[...state.collection].map((tab) => {
            if (tab.key === state.selectedKey) {
              return <TabPanel state={state} style={{ width: `${itemWithFraction}%` }} key={state.selectedItem?.key} />
            }
            return (
              <div className={Styles.tabContent} style={{ width: `${itemWithFraction}%` }} key={tab.key}>
                {tab.props.children}
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
